import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Toaster } from 'react-hot-toast';

const container = document.getElementById('root');

const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <>
      <Toaster
        position="top-center"
        reverseOrder={false}
      />
      <App />
    </>
  </React.StrictMode>
);
